import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Select from '@zg-rentals/multibrand-ui/lib/Select';

// rmw context
import { RMWContext } from 'app/shared/providers/RMWContext';

// containers
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

import HeadWrapper from 'app/shared/components/HeadWrapper';

import ViewGraph from 'app/shared/components/Graphs/ViewGraph';
import LeadClickGraph from 'app/shared/components/Graphs/LeadClickGraph';
import PropertyGraph from 'app/shared/components/Graphs/PropertyGraph';
import ReviewGraph from 'app/shared/components/Graphs/ReviewGraph';
import InvoiceGraph from 'app/shared/components/Graphs/InvoiceGraph';

// Actions
import AnalyticsActions from 'app/shared/actions/AnalyticsActions';

// Selectors
import { UserSelectors, AnalyticsSelectors } from 'app/shared/selectors';

// Stylesheets
import './style.scss';

const propTypes = {
    graphs: PropTypes.object.isRequired,
    overviewFilter: PropTypes.object.isRequired,
};

class OverviewPage extends React.Component {
    static contextType = RMWContext;

    constructor(props) {
        super(props);

        this.state = {
            isLoadingReviewsGraph: true,
            isLoadingListingsGraph: true,
            isLoadingInvoicesGraph: true,
            isLoadingListings: true,
        };
        this.handlePropertyChange = this.handlePropertyChange.bind(this);
    }

    componentDidMount() {
        this.getGraphs();
    }

    getGraphs(filterKey = '') {
        const { dispatch } = this.props;
        this.setState({
            isLoadingListingsGraph: true,
            isLoadingReviewsGraph: true,
            isLoadingInvoicesGraph: true,
            filterKey,
        });
        const params = {};
        if (filterKey) {
            const matchedListingId = filterKey.match(/listingId:(.*)/);
            const matchedRocketshipFilter = filterKey.match(/rocketshipFilter:(.*)/);
            if (matchedListingId != null) {
                params.listingId = matchedListingId[1];
            } else if (matchedRocketshipFilter != null) {
                params.rocketshipFilter = matchedRocketshipFilter[1];
            }
        }

        dispatch(AnalyticsActions.getOverviewFilter())
            .then(() => this.setState({ isLoadingListings: false }))
            .catch(() => this.setState({ isLoadingListings: false }));
        dispatch(AnalyticsActions.getGraphs('reviews', params))
            .then(() => this.setState({ isLoadingReviewsGraph: false }))
            .catch(() => this.setState({ isLoadingReviewsGraph: false }));
        dispatch(AnalyticsActions.getGraphs('listings', params))
            .then(() => this.setState({ isLoadingListingsGraph: false }))
            .catch(() => this.setState({ isLoadingListingsGraph: false }));
        dispatch(AnalyticsActions.getMonthlyOverviewStats(params))
            .then(() => this.setState({ isLoadingInvoicesGraph: false }))
            .catch(() => this.setState({ isLoadingInvoicesGraph: false }));
    }

    handlePropertyChange(e) {
        this.getGraphs(e.target.value);
    }

    renderContent() {
        const {
            isLoadingListings,
            isLoadingReviewsGraph,
            isLoadingListingsGraph,
            isLoadingInvoicesGraph,
            filterKey,
        } = this.state;
        const { brand } = this.context;
        const {
            graphs,
            overviewFilter,
        } = this.props;
        let filterOptions = [
            <option key="" value="">All properties</option>,
            ...overviewFilter.listings.map(listing => (
                <option key={listing.listingId} value={`listingId:${listing.listingId}`}>{listing.name}</option>
            )),
        ];

        filterOptions = filterOptions.concat(...overviewFilter.rocketshipAccounts.map(account => (
            <option
                key={account.zillowAccountId}
                value={`rocketshipFilter:${account.customerId}_${account.zillowAccountId}`}
            >
                {account.billingAccountName}
            </option>
        )));

        const isLoading = isLoadingListings
            || isLoadingReviewsGraph
            || isLoadingListingsGraph
            || isLoadingInvoicesGraph;

        const isAllProperties = !filterKey;

        return (
            <React.Fragment>
                {filterOptions.length > 2 && (
                    <Row className="OverviewPage-top-row">
                        <Col className="OverviewPage-col" md={12} lg={5} xl={5}>
                            <Select
                                name="sort"
                                value={filterKey}
                                onChange={this.handlePropertyChange}
                                disabled={isLoading}
                            >
                                {filterOptions}
                            </Select>
                        </Col>
                    </Row>
                )}
                {isAllProperties && (
                    <PropertyGraph
                        brand={brand}
                        data={graphs.property}
                        isLoading={isLoadingListingsGraph}
                    />
                )}
                <ViewGraph
                    brand={brand}
                    data={graphs.view}
                    isLoading={isLoadingListingsGraph}
                    showTabs={isAllProperties}
                />
                <LeadClickGraph
                    brand={brand}
                    data={graphs.leadClick}
                    isLoading={isLoadingListingsGraph}
                    showTabs={isAllProperties}
                />
                <ReviewGraph
                    brand={brand}
                    data={graphs.review}
                    isLoading={isLoadingReviewsGraph}
                />
                <InvoiceGraph
                    brand={brand}
                    data={graphs.invoice}
                    isLoading={isLoadingInvoicesGraph}
                />
            </React.Fragment>
        );
    }

    render() {
        return (
            <AuthCheckWrapper requireStrongAuthentication={false}>
                <div className="OverviewPage">
                    <HeadWrapper title="Analytics Overview" />
                    {this.renderContent()}
                </div>
            </AuthCheckWrapper>
        );
    }
}

const mapStateToProps = state => ({
    user: UserSelectors.makeUser(state),
    graphs: AnalyticsSelectors.makeGraphs(state),
    overviewFilter: AnalyticsSelectors.makeOverviewFilter(state),
});

OverviewPage.propTypes = propTypes;

export { OverviewPage };
export default connect(mapStateToProps)(OverviewPage);
